import { AlertTriangle } from 'lucide-react'
import './PausedAccountBanner.css'

/**
 * Displayed at the top of every page when the signed-in user's account
 * status is 'paused'. The user can still navigate but all write operations
 * are blocked server-side. This banner explains why things aren't working.
 */
export default function PausedAccountBanner() {
  return (
    <div className="paused-banner" role="alert">
      <AlertTriangle size={18} className="paused-banner__icon" />
      <span className="paused-banner__text">
        Your account has been paused. You can view your data but cannot make
        changes.{' '}
        <a href="mailto:support@back40engineering.com" className="paused-banner__link">
          Contact support
        </a>{' '}
        to restore access.
      </span>
    </div>
  )
}
